// /* global googletag */
/* eslint no-undef: "error" */

export default {
  watch: {
    adsInitialized () {
      // const ignoreRoutenames = ['UserProfile', 'MyProfile', 'Reviewdetail', 'BestBusiness-Category']
      // if (this.adsInitialized === this.totalAds && !ignoreRoutenames.includes(this._routeName)) {
      //   googletag.cmd.push(() => {
      //     googletag.pubads().setTargeting('Pagetype', this._routeName)
      //     googletag.pubads().setTargeting('URL', window.location.href)
      //     googletag.pubads().collapseEmptyDivs()
      //     googletag.enableServices()
      //   })
      // }
      // console.log('watch, adsInitialized')
      // if (this.totalAds > 0 && this.totalAds === this.adsInitialized) {
      //   const fusetag = window.fusetag || (window.fusetag = { que: [] })
      //   const adConfig = require('../misc/fuse_ad_config_object.js')
      //   const _data = this.isMobileAds ? adConfig.mobile[this._routeName] : adConfig.desktop[this._routeName]
      //   const ids = _data.map(obj => obj.slotName)
      //   console.log('fusetag.que.push called')
      //   fusetag.que.push(() => {
      //     fusetag.pageInit({
      //       blockingFuseIds: ids
      //     })
      //   })
      // }
    }
  },
  created () {
    this.doneFetchingDependantData = true
    const isMobile = window.innerWidth <= 767
    this.isMobileAds = window.isMobileAds = isMobile
    this.adsForPage = []
    window.fusetag = window.fusetag || (window.fusetag = { que: [] })
  },
  mounted () {
    // this.pushFuseAds()
    this.pushAdsWhenConditionsAreMet(() => this.doneFetchingDependantData)
  },
  methods: {
    loadFuseAds (nameOverride = this.$route.name) {
      const isMobile = window.innerWidth <= 767
      this.isMobileAds = window.isMobileAds = isMobile
      this._routeName = nameOverride

      this.adsForPage = []
      window.fusetag = window.fusetag || (window.fusetag = { que: [] })
      // const adConfig = require('../misc/fuse_ad_config_object.js')
      // if (!isMobile || (isMobile && typeof adConfig.mobile[nameOverride] !== 'undefined')) {
      //   this.adsInitialized = 0
      //   this.totalAds = isMobile ? adConfig.mobile[nameOverride].length : adConfig.desktop[nameOverride].length
      // }
    },
    updateAdsListForPage (event) {
      console.log('updateAdsListForPage', event)
      this.adsForPage.push(event.name)
    },
    /**
     * Use promise to not block the page. This is meant so that we can push to ads only once all necessary waiting is
     * complete. For example, on the reviews detail page we are conditionally loading ads after we get results back from the
     * call to fetch other reviews in the same buzuiness or category.
     *
     * @param {Function} conditionFn - A function that returns a boolean based on whether a condition was met so that we can proceed to push ads
     * @param {number} [checkInterval=100] - The interval in milliseconds between when it needs to check the condition
     *
     * @returns {Promise<void>} - A promise that resolves once the condition returns true
     */
    waitTillSafeToPushAds (conditionFn, checkInterval = 100) {
      return new Promise(resolve => {
        const intervalId = setInterval(() => {
          if (conditionFn()) {
            clearInterval(intervalId)
            resolve()
          }
        }, checkInterval);
      })
    },
    /**
     * Asynchronously waits for a condition to be met, then executes the provided callback.
     *
     * @param {Function} conditionFn - A function that returns a boolean representing the condition.
     * @param {number} [checkInterval=100] - The interval in milliseconds between each condition check.
     * @returns {Promise<void>}
     */
    async pushAdsWhenConditionsAreMet (conditionFn, checkInterval = 100) {
      await this.waitTillSafeToPushAds(conditionFn, checkInterval)
      this.pushFuseAds()
    },
    /**
     * Register and push ads to Fuse
     *
     * @returns {void}
     */
    pushFuseAds () {
      console.log('pushFuseAds')
      this.adsForPage.forEach(a => {
        window.fusetag.registerZone(a)
        console.log('called registerZone for', a)
      })
      const ids = this.adsForPage
      const fusetag = window.fusetag || (window.fusetag = { que: [] })
      console.log('about to call push', ids)
      fusetag.que.push(() => {
        console.log('inside fusetag.que.push', 'blockingFuseIds', ids)
        fusetag.pageInit({
          blockingFuseIds: ids
        })
        console.log('after fusetag.pageInit', 'blockingFuseIds', ids)
      })
      console.log('after push call')
    },
    updateAdCounter () {
      this.adsInitialized++
      console.log('updateAdCounter called')
      // if (this.totalAds > 0 && this.totalAds === this.adsInitialized) {
      //   const fusetag = window.fusetag || (window.fusetag = { que: [] })
      //   const adConfig = require('../misc/fuse_ad_config_object.js')
      //   const _data = this.isMobileAds ? adConfig.mobile[this._routeName] : adConfig.desktop[this._routeName]
      //   const ids = _data.map(obj => obj.slotName)
      //   console.log('fusetag object', fusetag)
      //   console.log('fusetag.que.push called with ids:', ids)
      //   fusetag.registerAll()
      //   fusetag.que.push(() => {
      //     console.log('inside fusetag.que.push', 'blockingFuseIds', ids)
      //     fusetag.pageInit({
      //       blockingFuseIds: ids
      //     })
      //     console.log('after fusetag.pageInit', 'blockingFuseIds', ids)
      //   })
      //   console.log('after fusetag.que.push', 'blockingFuseIds', ids)
      // } else {
      //   console.log('did not call fusetag.que.push', 'totalAds', this.totalAds, 'adsInitialized', this.adsInitialized)
      // }
    },
    loadAds (nameOverride = this.$route.name) {
      this._routeName = nameOverride
      const isMobile = window.innerWidth <= 767
      this.isMobileAds = window.isMobileAds = isMobile
      const adConfig = require('../misc/ad_config_object.js')

      if (!isMobile || (isMobile && typeof adConfig.mobile[nameOverride] !== 'undefined')) {
        this.adsInitialized = 0
        this.totalAds = isMobile ? adConfig.mobile[nameOverride].length : adConfig.desktop[nameOverride].length
        const m = (_index, data) => {
          return {
            index: _index + 1,
            slotName: data.slotName,
            slotParams: data.slotParams,
            targetingParams: data.targetingParams
          }
        }

        const _data = isMobile ? adConfig.mobile[nameOverride] : adConfig.desktop[nameOverride]
        let [one, two, three, four, five, six, seven] = [{}, {}, {}, {}, {}, {}, {}]
        _data.forEach((data, index) => {
          switch (index) {
            case 0:
              one = m(index, data)
              break
            case 1:
              two = m(index, data)
              break
            case 2:
              three = m(index, data)
              break
            case 3:
              four = m(index, data)
              break
            case 4:
              five = m(index, data)
              break
            case 5:
              six = m(index, data)
              break
            default:
              seven = m(index, data)
              break
          }
        })

        this.firstAd = one
        this.secondAd = two
        this.thirdAd = three
        this.fourthAd = four
        this.fifthAd = five
        this.sixthAd = six
        this.seventhAd = seven
      }
    }
  },
  /**
  * beforeCreate - restore the below if we're going back to the old ads service
  */
  // beforeCreate () {
  //   window.googletag.cmd.push(() => {
  //     window.googletag.destroySlots()
  //     import FuseAd from './ProgrammaticFuseAds'
  //   })
  // },
  data () {
    return {
      doneFetchingDependantData: true,
      adsForPage: [],
      adsInitialized: 0,
      totalAds: 0,
      isMobileAds: false,
      hideFirstDesktopAd: true,
      firstAd: {},
      secondAd: {},
      thirdAd: {},
      fourthAd: {},
      fifthAd: {},
      sixthAd: {},
      seventhAd: {},
      _routeName: this.$route.name
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ad_config.js